var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmsMagic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 119,
    viewBox: "0 0 180 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.185 39.9716L145.508 20.7715L112.508 40.0637L146.185 59.2637L112.277 79.0789L145.939 98.2789L179.4 78.7099L179.185 39.9716Z",
    fill: "#F58615"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.446 29.5691L51.8924 0L0.307691 29.4153L0 88.7689L51.2615 118.723L102.8 89.323L50.8769 58.969L102.446 29.5691Z",
    fill: "#F58615"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsMagic);
export default __webpack_public_path__ + "static/media/SMS-Magic.e1af5a5903f03dc837225f7df53cac4f.svg";
export { ForwardRef as ReactComponent };